import { FC } from 'react';
import { IonContent } from '@ionic/react';
import PageHeader from '../../components/headers/PageHeader';
import { useTranslation } from 'react-i18next';
import GiftCardsCheckoutScreen from '../../../../pages/gift-cards/checkout/GiftCardsCheckoutScreen';

const GiftCardsCheckoutPage: FC = () => {
  const { t } = useTranslation(null, { keyPrefix: 'Modules:Mobile:Pages:CheckoutPage' });

  return (
    <>
      <PageHeader title={t('title')} />
      <IonContent>
        <GiftCardsCheckoutScreen />
      </IonContent>
    </>
  );
};

export default GiftCardsCheckoutPage;
